import { PropsWithChildren, ReactNode } from 'react';

type Props = PropsWithChildren<{
    title: ReactNode;
    actions?: ReactNode;
}>

export const ProjectSelectionDeviceList = ({ title, actions, children }: Props) => (
    <div className="vss-project-selection-device-list">
        <div className="vss-project-selection-device-list__header">
            {title}
            {actions !== undefined && actions}
        </div>

        <div className="vss-project-selection-device-list__list">
            {children}
        </div>
    </div>
);
